var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgList(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41.038,
    height: 43.519,
    viewBox: "0 0 41.038 43.519",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-13.203 -6.363)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(12.84 6)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.363 0.363)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.546,51.519H16.423a1.582,1.582,0,0,1-1.582-1.582V9.582A1.582,1.582,0,0,1,16.423,8H47.546a1.582,1.582,0,0,1,1.582,1.582V49.936a1.582,1.582,0,0,1-1.582,1.583Z",
    transform: "translate(-14.841 -8)",
    fill: "#bfd65c"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.978 8.704)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.013,57.264H40.837a.544.544,0,0,1-.544-.544V54.544A.544.544,0,0,1,40.837,54h2.176a.544.544,0,0,1,.544.544V56.72A.544.544,0,0,1,43.013,57.264Z",
    transform: "translate(-40.293 -54)",
    fill: "#f7f7f7"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.89 18.714)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.476,111.308H35.343a1.05,1.05,0,1,1,0-2.1H60.476a1.05,1.05,0,1,1,0,2.1Z",
    transform: "translate(-34.293 -109.207)",
    fill: "#004377"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.89 28.144)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.476,163.308H35.343a1.05,1.05,0,1,1,0-2.1H60.476a1.05,1.05,0,1,1,0,2.1Z",
    transform: "translate(-34.293 -161.207)",
    fill: "#004377"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(15.858 8.704)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M103.013,57.264h-2.176a.544.544,0,0,1-.544-.544V54.544a.544.544,0,0,1,.544-.544h2.176a.544.544,0,0,1,.544.544V56.72A.544.544,0,0,1,103.013,57.264Z",
    transform: "translate(-100.293 -54)",
    fill: "#f7f7f7"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(26.738 8.704)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M163.013,57.264h-2.176a.544.544,0,0,1-.544-.544V54.544a.544.544,0,0,1,.544-.544h2.176a.544.544,0,0,1,.544.544V56.72A.544.544,0,0,1,163.013,57.264Z",
    transform: "translate(-160.293 -54)",
    fill: "#f7f7f7"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.978 22.847)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.013,135.264H40.837a.544.544,0,0,1-.544-.544v-2.176a.544.544,0,0,1,.544-.544h2.176a.544.544,0,0,1,.544.544v2.176A.544.544,0,0,1,43.013,135.264Z",
    transform: "translate(-40.293 -132)",
    fill: "#f7f7f7"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(15.858 22.847)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M103.013,135.264h-2.176a.544.544,0,0,1-.544-.544v-2.176a.544.544,0,0,1,.544-.544h2.176a.544.544,0,0,1,.544.544v2.176A.544.544,0,0,1,103.013,135.264Z",
    transform: "translate(-100.293 -132)",
    fill: "#f7f7f7"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(26.738 22.847)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M163.013,135.264h-2.176a.544.544,0,0,1-.544-.544v-2.176a.544.544,0,0,1,.544-.544h2.176a.544.544,0,0,1,.544.544v2.176A.544.544,0,0,1,163.013,135.264Z",
    transform: "translate(-160.293 -132)",
    fill: "#f7f7f7"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.978 36.991)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.013,213.264H40.837a.544.544,0,0,1-.544-.544v-2.176a.544.544,0,0,1,.544-.544h2.176a.544.544,0,0,1,.544.544v2.176A.544.544,0,0,1,43.013,213.264Z",
    transform: "translate(-40.293 -210)",
    fill: "#f7f7f7"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(15.858 36.991)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M103.013,213.264h-2.176a.544.544,0,0,1-.544-.544v-2.176a.544.544,0,0,1,.544-.544h2.176a.544.544,0,0,1,.544.544v2.176A.544.544,0,0,1,103.013,213.264Z",
    transform: "translate(-100.293 -210)",
    fill: "#f7f7f7"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(15.592 7.167)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M100.545,49.885h0a.746.746,0,0,1-.6-.314l-1.021-1.438a.5.5,0,0,1,.81-.575l.82,1.154,2.144-2.98a.5.5,0,1,1,.806.58l-2.347,3.262A.747.747,0,0,1,100.545,49.885Z",
    transform: "translate(-98.825 -45.526)",
    fill: "#004377"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(15.592 21.311)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M100.545,127.885h0a.746.746,0,0,1-.6-.314l-1.021-1.438a.5.5,0,1,1,.81-.575l.82,1.154,2.144-2.98a.5.5,0,1,1,.806.58l-2.347,3.262A.747.747,0,0,1,100.545,127.885Z",
    transform: "translate(-98.825 -123.526)",
    fill: "#004377"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(23.268 23.428)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 9.066,
    cy: 9.066,
    r: 9.066,
    fill: "#f7f7f7"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(25.609 25.923)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M160.8,162.413a6.725,6.725,0,1,1,6.725-6.725A6.733,6.733,0,0,1,160.8,162.413Z",
    transform: "translate(-154.07 -148.963)",
    fill: "#bfd65c"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(26.948 28.31)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M165.227,171.682h-.005a1.636,1.636,0,0,1-1.327-.688l-2.238-3.153a1.089,1.089,0,0,1,1.776-1.261l1.8,2.532,4.7-6.536a1.089,1.089,0,1,1,1.768,1.272L166.553,171A1.637,1.637,0,0,1,165.227,171.682Z",
    transform: "translate(-161.455 -162.123)",
    fill: "#004377"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgList);
export default __webpack_public_path__ + "static/media/list.f689746dcf1e3abde5b698503399a924.svg";
export { ForwardRef as ReactComponent };